// extracted by mini-css-extract-plugin
module.exports = {"markdownStyle":"Markdown_markdownStyle__2G0LG"};